// THIS IS A GENERATED FILE
import * as Types from "../../graphql/types"

import gql from "graphql-tag"
import * as ApolloReactCommon from "@apollo/react-common"
import * as ApolloReactHooks from "@apollo/react-hooks"

export type NetlifyAccountsListQueryVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
}>

export type NetlifyAccountsListQuery = { __typename?: "Query" } & {
  netlifyAccountsForGatsbySiteId?: Types.Maybe<
    Array<
      Types.Maybe<
        { __typename?: "NetlifyAccount" } & Pick<
          Types.NetlifyAccount,
          "id" | "name" | "slug"
        >
      >
    >
  >
}

export type NetlifySitesListQueryVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  slug: Types.Scalars["String"]
}>

export type NetlifySitesListQuery = { __typename?: "Query" } & {
  netlifySitesForGatsbySiteId?: Types.Maybe<
    Array<
      Types.Maybe<
        { __typename?: "NetlifySite" } & Pick<
          Types.NetlifySite,
          "id" | "name" | "accountName"
        >
      >
    >
  >
}

export type CreateNetlifySiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  serviceName: Types.Scalars["String"]
  accountName: Types.Scalars["String"]
}>

export type CreateNetlifySiteMutation = { __typename?: "Mutation" } & {
  createNetlifySite?: Types.Maybe<
    { __typename?: "NetlifyCreateSiteResult" } & {
      validation?: Types.Maybe<
        { __typename?: "MutationResult" } & Pick<
          Types.MutationResult,
          "success" | "message"
        >
      >
      netlifySite?: Types.Maybe<
        { __typename?: "NetlifySite" } & Pick<
          Types.NetlifySite,
          "id" | "name" | "accountName"
        >
      >
    }
  >
}

export type NetlifyAddedSubscriptionVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
}>

export type NetlifyAddedSubscription = { __typename?: "Subscription" } & Pick<
  Types.Subscription,
  "netlifyIntegrationAdded"
>

export const NetlifyAccountsListDocument = gql`
  query NetlifyAccountsList($siteId: UUID!) {
    netlifyAccountsForGatsbySiteId(siteId: $siteId) {
      id
      name
      slug
    }
  }
`

/**
 * __useNetlifyAccountsListQuery__
 *
 * To run a query within a React component, call `useNetlifyAccountsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetlifyAccountsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetlifyAccountsListQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useNetlifyAccountsListQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    NetlifyAccountsListQuery,
    NetlifyAccountsListQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    NetlifyAccountsListQuery,
    NetlifyAccountsListQueryVariables
  >(NetlifyAccountsListDocument, baseOptions)
}
export function useNetlifyAccountsListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    NetlifyAccountsListQuery,
    NetlifyAccountsListQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    NetlifyAccountsListQuery,
    NetlifyAccountsListQueryVariables
  >(NetlifyAccountsListDocument, baseOptions)
}
export type NetlifyAccountsListQueryHookResult = ReturnType<
  typeof useNetlifyAccountsListQuery
>
export type NetlifyAccountsListLazyQueryHookResult = ReturnType<
  typeof useNetlifyAccountsListLazyQuery
>
export type NetlifyAccountsListQueryResult = ApolloReactCommon.QueryResult<
  NetlifyAccountsListQuery,
  NetlifyAccountsListQueryVariables
>
export const NetlifySitesListDocument = gql`
  query NetlifySitesList($siteId: UUID!, $slug: String!) {
    netlifySitesForGatsbySiteId(siteId: $siteId, slug: $slug) {
      id
      name
      accountName
    }
  }
`

/**
 * __useNetlifySitesListQuery__
 *
 * To run a query within a React component, call `useNetlifySitesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetlifySitesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetlifySitesListQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useNetlifySitesListQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    NetlifySitesListQuery,
    NetlifySitesListQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    NetlifySitesListQuery,
    NetlifySitesListQueryVariables
  >(NetlifySitesListDocument, baseOptions)
}
export function useNetlifySitesListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    NetlifySitesListQuery,
    NetlifySitesListQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    NetlifySitesListQuery,
    NetlifySitesListQueryVariables
  >(NetlifySitesListDocument, baseOptions)
}
export type NetlifySitesListQueryHookResult = ReturnType<
  typeof useNetlifySitesListQuery
>
export type NetlifySitesListLazyQueryHookResult = ReturnType<
  typeof useNetlifySitesListLazyQuery
>
export type NetlifySitesListQueryResult = ApolloReactCommon.QueryResult<
  NetlifySitesListQuery,
  NetlifySitesListQueryVariables
>
export const CreateNetlifySiteDocument = gql`
  mutation CreateNetlifySite(
    $siteId: UUID!
    $serviceName: String!
    $accountName: String!
  ) {
    createNetlifySite(
      siteId: $siteId
      serviceName: $serviceName
      accountName: $accountName
    ) {
      validation {
        success
        message
      }
      netlifySite {
        id
        name
        accountName
      }
    }
  }
`
export type CreateNetlifySiteMutationFn = ApolloReactCommon.MutationFunction<
  CreateNetlifySiteMutation,
  CreateNetlifySiteMutationVariables
>

/**
 * __useCreateNetlifySiteMutation__
 *
 * To run a mutation, you first call `useCreateNetlifySiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNetlifySiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNetlifySiteMutation, { data, loading, error }] = useCreateNetlifySiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      serviceName: // value for 'serviceName'
 *      accountName: // value for 'accountName'
 *   },
 * });
 */
export function useCreateNetlifySiteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateNetlifySiteMutation,
    CreateNetlifySiteMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CreateNetlifySiteMutation,
    CreateNetlifySiteMutationVariables
  >(CreateNetlifySiteDocument, baseOptions)
}
export type CreateNetlifySiteMutationHookResult = ReturnType<
  typeof useCreateNetlifySiteMutation
>
export type CreateNetlifySiteMutationResult = ApolloReactCommon.MutationResult<
  CreateNetlifySiteMutation
>
export type CreateNetlifySiteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateNetlifySiteMutation,
  CreateNetlifySiteMutationVariables
>
export const NetlifyAddedDocument = gql`
  subscription NetlifyAdded($siteId: UUID!) {
    netlifyIntegrationAdded(siteId: $siteId)
  }
`

/**
 * __useNetlifyAddedSubscription__
 *
 * To run a query within a React component, call `useNetlifyAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNetlifyAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetlifyAddedSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useNetlifyAddedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    NetlifyAddedSubscription,
    NetlifyAddedSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    NetlifyAddedSubscription,
    NetlifyAddedSubscriptionVariables
  >(NetlifyAddedDocument, baseOptions)
}
export type NetlifyAddedSubscriptionHookResult = ReturnType<
  typeof useNetlifyAddedSubscription
>
export type NetlifyAddedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  NetlifyAddedSubscription
>
